// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3fa1J","inner":"Footer_inner__1enfN","nextIcon":"Footer_nextIcon__3zjSD","innerLeft":"Footer_innerLeft__2j3Ol"};